import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { EmptyState } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/** The table's body when nothing has been imported into the branch yet. */
export const ImportHistoryEmpty: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <EmptyState {...getNodeTestIdProp('branch-import-history-empty')}>
            <EmptyState.Header>
                <EmptyState.Media variant="icon">
                    <Icon
                        aria-hidden
                        icon="gravity-ui:clock-arrow-rotate-left"
                    />
                </EmptyState.Media>
                <EmptyState.Title>
                    {t('catalogImport.branchImport.history.empty.title')}
                </EmptyState.Title>
                <EmptyState.Description>
                    {t('catalogImport.branchImport.history.empty.description')}
                </EmptyState.Description>
            </EmptyState.Header>
        </EmptyState>
    );
};
